import './Modal.css';
import React from 'react';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import { CloseButton } from '../../atoms/CloseButton/CloseButton';
import { IconDots } from '../../atoms/Icons';
import ComponentsWrapper from '../../atoms/ComponentsWrapper';
import { useOnKeyPress } from '../../../utils/hooks/useOnKeyPress';

// import Loader from '../../loader';

var Modal = function Modal(_ref) {
  var rtl = _ref.rtl,
    hide = _ref.hide,
    dictionary = _ref.dictionary,
    children = _ref.children,
    title = _ref.title,
    description = _ref.description;
  useOnKeyPress(['Escape', 'Esc'], hide);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    role: "dialog",
    "aria-labelledby": "wizard-title"
  }, /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal__container"
  }, /*#__PURE__*/React.createElement(CloseButton, {
    className: "modal__close",
    onClick: hide
  }), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-1 "
  }, /*#__PURE__*/React.createElement(IconDots, {
    className: "modal__icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-11 "
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal__col"
  }, title && /*#__PURE__*/React.createElement(Text, {
    tag: "h4",
    className: "h4",
    field: {
      value: title
    }
  }), description && /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    className: "description",
    field: {
      value: description
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal__actions"
  }, children))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: " "
  }, children);
};
export default Modal;
var commonStyles = "c16mqosh";
var rtlStyles = "rkaaoc4";
var ltrStyles = "lqb7xo3";